module.exports = __webpack_public_path__ + "images/home/product/wechat-miniprogram-device-left-fb5c07fd20513c057f5ae4ce93f485be.png";